import { ordersUrl } from "../resources";
import getRequest from '../common/getRequest.js';


async function getOrdersByDateAndRestaurantId(restaurantId, createdDate, token) {

    let url = `${ordersUrl}/getordersbydateandrestaurant/${restaurantId}/${createdDate}`;

    let data = null;

    await getRequest.getDataWithToken(url)
                    .then( res => {
                        data = res.orders
                    });
    return data;
}

export default { 
    getOrdersByDateAndRestaurantId
}